import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import basicStyles from '../../styles.module.scss'

export default function UnauthorizedSideMenu(props) {
  const { clickAction, t, handleLink } = props
  return (
    <React.Fragment>
      <div className={styles.burger}>
        <button className={styles.menuButton} onClick={clickAction}>
          <Icon name='menu' size='large40' styleModifier={styles.menuIcon} />
        </button>
      </div>
      <a className={styles.menuItem} href={config.webUrl + '/0/signup'}>
        <span className={`${styles.icon} ${styles.registerIcon}`} />
        <span>{t('nav.register')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/auth'}>
        <span className={`${styles.icon} ${styles.loginIcon}`} />
        <span>{t('global.login')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={'https://community.mixr.net/product'}>
        <span className={`${styles.icon} ${styles.productIcon}`} />
        <span>{t('nav.product')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/communities-at-work/solutions'}>
        <Icon name='solutions' size='xlarge' alt='solutions' />
        <span>{t('nav.solutions')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/contact-us'}>
        <span className={`${styles.icon} ${styles.contactIcon}`} />
        <span>{t('nav.contact')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/communities-at-work/learn-more/about'}>
        <span className={`${styles.icon} ${styles.aboutIcon}`} />
        <span>{t('nav.about')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/blog/communities'}>
        <span className={`${styles.icon} ${styles.blogIcon}`} />
        <span>{t('nav.blog')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/communities-at-work/learn-more/press'}>
        <Icon name='press' size='xlarge' alt='press' />
        <span>{t('nav.press')}</span>
      </a>
      <hr className={basicStyles.divider} />
      <a className={styles.menuItem} href={config.webUrl + '/0/pricing'}>
        <Icon name='pricing' size='xlarge' alt='pricing' />
        <span>{t('nav.pricing')}</span>
      </a>
    </React.Fragment>
  )
}
